import React from "react";
import {observer} from "mobx-react";
import classNames from "classnames";
import styles from "../styles/filter-bar.module.scss";
import {Image} from "../../../core/components/image/image";

export const FilterBarModuleButton = observer(({
                                                          label,
                                                          shouldRenderButton,
                                                          isActive,
                                                          className,
                                                          onClick,
                                                          hasIcon,
                                                          isDisabled,
                                                          iconSource
                                                        }) => {

  const containerProps = {
    className: classNames(styles.button_filter, className, {[styles.button_filter_active]: isActive && !isDisabled}, {[styles.button_filter_disabled]: isDisabled}),
    onClick: () => !isDisabled && onClick?.(),
  }

  const iconProps = {
    className: classNames(styles.button_icon),
    src: iconSource
  }

  return shouldRenderButton ? <div {...containerProps}>
    {
      hasIcon ? <Image {...iconProps}/> : null
    }
    {label}
  </div> : null
});
